import React, { useState } from 'react'
import Constants from 'EurestoFonction/Constants'

import User from 'EurestoClass/User'
import Formulaire from 'Components/Formulaire'

import moment from 'moment'
import Search from '../../Component/Search'
import { Grid } from '@material-ui/core'

import { usePersistFn } from 'ahooks'

const columns = [{
    header: 'Id',
    id: 'id',
    show: false,
}, {
    header: 'Utilisateur',
    id: 'prenom',
    width: 30,
    type: 'string',
}, {
    id: 'path',
    header: 'Path',
    sortable: false,
    width: 30,
    type: 'string',
}, {
    id: 'requete',
    width: 30,
    header: 'Requête',
    type: 'string'
}, {
    id: 'action',
    width: 30,
    header: 'Type',
    type: 'string'
}, {
    id: 'json',
    minWidth: 250,
    header: 'Objet',
    type: 'string',
    Cell: row => <Grid container spacing={0} style={{ margin: 0, padding: 0, maxWidth: '100%', minWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', overflowWrap: 'break-word' }}>
        {row.json}
    </Grid>
}, {
    id: 'code',
    width: 30,
    header: 'Code',
    type: 'string'
}, {
    id: 'reponse',
    minWidth: 250,
    header: 'Réponse',
    type: 'string',
    Cell: row => <Grid container spacing={0} style={{ margin: 0, padding: 0, maxWidth: '100%', minWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', overflowWrap: 'break-word' }}>
        {row.reponse}
    </Grid>
}, {
    id: 'date_creation',
    width: 150,
    header: 'Date',
    type: 'string',
    Cell: row => {
        return moment(row.date_creation).format('DD/MM/YY HH:mm')
    }
}]


const isAllow = {
    add: false, update: false, delete: false
}
const formStyle = { padding: 0 }

export default React.memo(props => {

    const setAllow = usePersistFn((row) => ({
    }))

    const onClick = usePersistFn((row) => {
        console.log(row)
        const textArea = document.createElement('textarea')
        textArea.value = row.json
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('Copy')
        textArea.remove()
    })


    return <React.Fragment>
        <Formulaire
            infinityScroll={true}
            isAllow={isAllow}
            onClick={onClick}
            formStyle={formStyle}
            maxHeight={props.maxHeight}
            showSearchComponent={props && props.showSearch}
            searchComponent={props && props.showSearch && <Search
                defaultSearch={props && props.defaultSearch}
                searchName={props && props.searchName}
            />}
            setAllow={setAllow}
            showForm={false}
            search={props.search || ((props && props.searchName || 'api_historique_') + (props.name || '') + User.Entite.get().id)}
            title={props.title}
            module={Constants.module.COMMUN}
            requete={Constants.donnee.requete} columns={columns} />
    </React.Fragment>
})


// WEBPACK FOOTER //
// ./app/App/Module/Api/Page/Recherche/index.js